<template>
    <div class="section fp-auto-height fp-section section-anim fp-completely" data-section="projects-grid"
         data-anchor="projects-grid" style="height: 627px;">
        <!-- Begin of section wrapper -->
        <div class="section-wrapper fullwidth with-margin">
            <!-- content -->
            <div class="section-content">
                <!-- project list -->
                <div class="project-list grid-1 grid-md-2 grid-lg-3 anim">

                  <div class="item media media-square text-white">
                    <div class="media-img">
                      <img class="img img-block" src="/img/maitre-artisan.svg" alt="Maître Artisan"
                           style="display: none;">
                      <div class="img"
                           style="background-image:url('/img/maitre-artisan.svg'); background-repeat: no-repeat; background-position: center center; background-size: cover;background-color:white;"></div>
                    </div>
                    <div class="media-news">
                    </div>
                  </div>

                    <div class="item media media-square text-white" v-for="news in newsData.slice(0, itemsNumber)">
                        <div class="media-img">
                            <img class="img img-block" :src="news.image" :alt="news.altImg"
                                 style="display: none;">
                            <div class="img"
                                 :style="{ backgroundImage: 'url(' + news.image + ')' }"
                                 style="background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                        </div>
                        <div class="media-news">
                            <h5 class="sr-up-td1 date-align">{{ formatDate(news.date) }}</h5>
                            <h3 class="sr-up-td2 titre-size">{{news.title}}</h3>
                            <p class="pSpacer news-background">
                                {{ news.text }}
                            </p>
                        </div>
                        <div class="media-footer sr-up-td4" v-show="news.typeLink !== 'aucun'">
                            <div class="btns-action sr-up-td3 text-primary">
                                <div class="btn btn-normal btn-white spaceTop"
                                     @click="goToPage(news.typeLink, news.urlLink)">
                                    <span class="icon" v-if="news.typeLink == 'pdf'"><img src="img/pdf-icone.svg"
                                                                                          width="35px"></span>
                                    <span class="text">{{news.textLink}}</span>
                                    <span class="icon"
                                          v-if="news.typeLink === 'interne' || news.typeLink == 'externe'">
                                            <span class="arrow-right"></span>
                                        </span>
                                </div>
                            </div><!--btns-action-->
                        </div>
                    </div>

                  <div class="item media media-square text-white"  @click="goToPage('interne', '/label-vosges-terroir')">
                    <div class="media-img">
                      <img class="img img-block" src="/img/vosges-terroir-accueil.svg" alt="Je vois la vie en Vosges Terroir"
                           style="display: none;">
                      <div class="img"
                           style="background-image:url('/img/vosges-terroir-accueil.svg'); background-repeat: no-repeat; background-position: center center; background-size: cover;background-color:white;"></div>
                    </div>
                    <div class="media-news">
                    </div>
                  </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        name: "CroustiNews",
        props: ["itemsNumber", "newsData"],
        methods: {
            formatDate(newsDate) {
                moment.locale('fr');
                return moment(newsDate).format('ll');
            },
            goToPage(typeLink, urlLink) {
                switch (typeLink) {
                    case 'pdf':
                        window.open(urlLink, '_blank');
                        break;
                    case 'interne':
                        this.$router.push({ path: urlLink});
                        break;
                    case 'externe':
                        window.open(urlLink, '_blank');
                        break;
                }
            }
        }
    }
</script>

<style>
    .date-align {
        text-align: left;
        font-size: 20px;
    }

    .titre-size {
        text-align: left;
        font-size: 25px;
    }
    .media-news {
        width: 100%;
        padding: 2rem;
    }
    .news-background {
        background-color: rgba(253, 253, 253, 0.19);
        text-align:left;
        margin-top:10px;
    }
</style>